import { render, staticRenderFns } from "./card-selection.vue?vue&type=template&id=6ad23e24&"
import script from "./card-selection.vue?vue&type=script&lang=js&"
export * from "./card-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports